// Puntos de inspección C-TPAT — SRIUC EXACTO (bilingüe ES/ZH)
// Los nombres en este archivo son la fuente de verdad tanto para el formulario
// como para el reporte PDF consolidado.

export const INSPECTION_POINTS_19 = [
  { es: "Pared frontal",                                       zh: "前壁" },
  { es: "Lateral izquierdo",                                   zh: "左侧壁" },
  { es: "Lateral derecho",                                     zh: "右侧壁" },
  { es: "Piso (Suelo)",                                        zh: "地板" },
  { es: "Techo",                                               zh: "顶棚" },
  { es: "Puertas (Interior/Exterior)",                         zh: "车门（内外）" },
  { es: "Fuera tren de rodaje / Chasis",                       zh: "底盘/车架" },
  { es: "Inspección Sellos VVTT",                              zh: "VVTT 封条检查" },
  { es: "Inspección agrícola",                                 zh: "农业检查" },
  { es: "Por debajo de unidad",                                zh: "单位底部" },
  { es: "Exterior e interior de puertas (bisagras, uniones)",  zh: "车门内外（合页、连接处）" },
  { es: "Piso interior",                                       zh: "内地板" },
  { es: "Paredes laterales",                                   zh: "侧壁" },
  { es: "Pared frontal interior",                              zh: "前壁（内）" },
  { es: "Techo interior",                                      zh: "内顶棚" },
  { es: "Unidad de refrigeración",                             zh: "制冷装置" },
  { es: "Escape",                                              zh: "排气管" },
  { es: "Inspección Sellos VVTT",                              zh: "VVTT 封条检查" },
  { es: "Inspección agrícola",                                 zh: "农业检查" },
];

export const INSPECTION_POINTS_9 = [
  { es: "Pared frontal",                    zh: "前壁" },
  { es: "Lateral izquierdo",                zh: "左侧壁" },
  { es: "Lateral derecho",                  zh: "右侧壁" },
  { es: "Piso (Suelo)",                     zh: "地板" },
  { es: "Techo",                            zh: "顶棚" },
  { es: "Puertas (Interior/Exterior)",      zh: "车门（内外）" },
  { es: "Fuera tren de rodaje / Chasis",    zh: "底盘/车架" },
  { es: "Inspección Sellos VVTT",           zh: "VVTT 封条检查" },
  { es: "Inspección agrícola",              zh: "农业检查" },
];

export function buildPoints(type) {
  const list = type === "9_puntos" ? INSPECTION_POINTS_9 : INSPECTION_POINTS_19;
  return list.map((p, i) => ({
    number: i + 1,
    name: p.es,
    name_zh: p.zh,
    estado: "bueno",
    comentarios: "",
    photo: "",
  }));
}
